<div class="w-full h-auto flex flex-col gap-5 text-start">
    <div class="flex flex-wrap w-full gap-2 justify-between items-center">
        <p class="text-xl font-bold">{{title}}</p>
        <div class="p-2 rounded-[16px]" [ngClass]="[tagTextColor, tagBackgroundColor]">{{tag}}</div>
    </div>
    <div class="flex min-h-[60px]">
        <p class="text-neutral-800">{{description}}</p>
    </div>
    <ul class="flex flex-col gap-5">
        <li *ngFor="let item of listItems" class="flex gap-2">
            <img [src]="item.icon" class="w-[24px] h-[24px] drop-shadow"
                alt="{{ 'shared.icon' | transloco }}">
            <p class="text-neutral-800">{{ item.desc | transloco }}</p>
        </li>
    </ul>

    <div class="p-5 rounded-lg" [ngClass]="[noteTextColor, noteBackgroundColor]">
        <p>{{ note }}</p>
    </div>
</div>